import { connectToDatabase } from "@/components/Server/Database/MongoDB";
import Announcement from "@/components/Student/Announcements";
import StudentDashboardLayout from "@/components/Student/DashboardLayout";
import { useState } from "react";

const StudentAnnouncements = ({ brand }) => {
  const [state, setState] = useState([]);

  return (
    <StudentDashboardLayout
      submitAnnouncements={(announcements) => {
        setState(announcements);
      }}
      brand={JSON.parse(brand)}
      sidebar={true}
    >
      <Announcement announcements={state} />
    </StudentDashboardLayout>
  );
};

export const getServerSideProps = async (context) => {
  const domainName = context.req ? context.req.headers.host : null;

  const { db } = await connectToDatabase();

  const info = await db.collection("partners").findOne({
    key: process.env.DEFAULT || domainName,
  });

  if (!info) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      brand: JSON.stringify(info),
    },
  };
};

export default StudentAnnouncements;
